import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { stringify, parse } from '../utils/query';
import { assign, camelCase, isEmpty, omitBy, reduce, snakeCase } from '../utils/lodash';
import '../scss/explorer_app.scss';
import { Form, Result, Spinner } from '../components';
import countriesList from '../fixtures/countries';
import { fetchResultsIfNeeded, requestFormOptions } from '../actions';
import './App.scss';
import { SubmissionError } from 'redux-form';
import { MexicoResult, CanadaResult } from '../components/Result/StaticResult';

class App extends Component {
  componentDidMount() {
    const { dispatch, query } = this.props;
    dispatch(requestFormOptions());
    dispatch(fetchResultsIfNeeded(query));
  }

  handlePaging = (e) => {
    e.preventDefault();
    if (!e.target.dataset.page) return;

    const { dispatch, query } = this.props;
    const offset = (parseInt(e.target.dataset.page, 10) - 1) * 10;
    const params = assign({}, omitBy(query, isEmpty), { offset });
    dispatch(fetchResultsIfNeeded(params));
    this.push(params);
  }

  handleSubmit = (form) => {
    const error = {};
    if(!form.tradeFlow)
      error.tradeFlow = 'This field is required.';
    if(!form.countries)
      error.countries = 'This field is required.';
    if(!isEmpty(error))
      throw new SubmissionError(error);

    const params = reduce(omitBy(form, isEmpty), (result, value, _key) => {
      const key = snakeCase(_key);
      return assign(
        result, { [key]: Array.isArray(value) ? value.join(',') : value });
    }, {});
    this.props.dispatch(fetchResultsIfNeeded(params));
    this.push(params);
    const { x, y } = (this.props.scroll_coordinates || { x: 0, y: 0 });
    window.scrollTo(x || 0, y || 0);
  }

  push(params) {
    this.props.history.push(`?${stringify(params)}`);
  }

  render() {
    const { query, results, form_options } = this.props;
    const formValues = reduce(
      query,
      (result, value, key) => assign(result, { [camelCase(key)]: value }),
      {});
    let result = <Result results={results} onPaging={this.handlePaging} query={query} />;
    if (query.countries === 'Mexico')
      result = <MexicoResult />;
    else if (query.countries === 'Canada')
      result = <CanadaResult />;
    const sourceCountries = (form_options && form_options.countries && form_options.countries.length) ? form_options.countries : countriesList;
    const normalizedCountries = sourceCountries.map(c => ({ label: c.label || c.value, value: c.label || c.value }));
    const effectiveFormOptions = Object.assign({}, form_options, {
      countries: normalizedCountries
    });

    return (
      <div className="explorer">
        <div className="explorer__form-wrapper">
          <Form onSubmit={this.handleSubmit} initialValues={formValues} formOptions={effectiveFormOptions} />
          <Spinner active={results.isFetching} />
        </div>
        {result}
      </div>
    );
  }
}
App.propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
  results: PropTypes.object,
  scroll_coordinates: PropTypes.object,
};

function mapStateToProps(state, ownProps) {
  const query = parse(ownProps.history.location.search.substring(1));
  const { results, form_options } = state;
  return {
    query,
    results,
    form_options
  };
}

export default connect(mapStateToProps)(App);
